"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    id: "logo-qustodio",
    d: "M41.105,1.6a11.936,11.936,0,0,0-5.39-.075c-3.239.613-5.665,3.614-5.665,3.614S26.3,9.863,27.174,15.516s6.378,5.9,7.254,5.878a20.231,20.231,0,0,0,2.789-.363.1.1,0,0,1,.125.138,5.15,5.15,0,0,0-.213,2.126A3.6,3.6,0,0,0,38,25.584c.913,1.026,1.138-.35,1.151-.588.113-2.114.2-3.989,3.289-7.766a10.6,10.6,0,0,0,1.638-2.989,18.248,18.248,0,0,0,1.276-7.179C45.295,2.872,41.105,1.6,41.105,1.6Zm.688,10.818s-1.3,5.778-5.965,7.016a6.937,6.937,0,0,1-2.164.013,3.958,3.958,0,0,1-3.339-3.552,13.988,13.988,0,0,1,1.126-7.879s1.863-4.7,5.79-4.865c0,0,3.814-.725,4.827,2.8C42.856,8.688,41.793,12.415,41.793,12.415Z",
    fill: "#fff"
  })
});

var Qustodio = function Qustodio(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Qustodio-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '24 1.1 25 25';
  }

  if (!mainDimension) {
    mainDimension = 'y';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Qustodio;
exports["default"] = _default;

//# sourceMappingURL=index.js.map